import Vue from "vue";
import { checkResponse } from "@/helpers/store";
import {
  nameFirme,
  kindName,
  countFirme,
  userName,
  payName
} from "@/helpers/reference";

const state = {
  packsReceiptsFilter: {
    period: {
      enabled: false,
      dateBegin: "",
      dateEnd: ""
    },
    organization: {
      enabled: false,
      code: null
    },
    payment: {
      enabled: false,
      code: null
    },
    sum: {
      enabled: false,
      sumBegin: null,
      sumEnd: null
    },
    showSpaced: {
      enabled: false
    }
  },
  packsReceipts: {
    data: []
  },
  infoReceipts: {
    data: []
  },
  importTypes: {
    data: []
  },
  importTypesLoading: false,
  statusModifyPacksReceipts: null,
  statusInfoImportFile: false,
  statusAddCodeplat: null,
  statusLoadPackFile: null,
  statusLoadPackFileCheck: null,
  statusImportFileCodeFirme: null,
  statusAddBand: null,
  importFiles: {
    data: []
  },
  importFilesBuffer: {
    data: []
  }
};

const mutations = {
  setPacksReceiptsFilter: (state, payload) =>
    (state.packsReceiptsFilter = payload),
  setPacksReceipts: (state, payload) => (state.packsReceipts = payload),
  clearPacksReceipts: state => (state.packsReceipts = { data: [] }),
  setInfoReceipts: (state, payload) => (state.infoReceipts = payload),
  clearInfoReceipts: state => (state.infoReceipts = { data: [] }),
  setStatusModifyPacksReceipts: (state, payload) =>
    (state.statusModifyPacksReceipts = payload),
  clearStatusModifyPacksReceipts: state =>
    (state.statusModifyPacksReceipts = null),
  setImportTypes: (state, payload) => (state.importTypes = payload),
  clearImportTypes: state => (state.importTypes = { data: [] }),
  setImportTypesLoading: (state, payload) =>
    (state.importTypesLoading = payload),
  setImportFiles: (state, payload) => {
    const allImportFiles = [...state.importFiles.data, ...payload];
    const uniqueImportFiles = [
      ...new Map(allImportFiles.map(item => [item.impFile, item])).values()
    ];
    state.importFiles.data = uniqueImportFiles;
  },
  setImportFilesBuffer: (state, payload) => (state.importFilesBuffer = payload),
  clearImportFiles: state => (state.importFiles = { data: [] }),
  clearImportFilesBuffer: state => (state.importFilesBuffer = { data: [] }),
  setStatusInfoImportFile: (state, payload) =>
    (state.statusInfoImportFile = payload),
  removeImportFile: (state, payload) => {
    state.importFiles.data = [
      ...state.importFiles.data.filter(item => item.impFile !== payload.impFile)
    ];
  },
  setErrorImportFile: (state, payload) => {
    const index = state.importFiles.data.findIndex(
      item => item.impFile === payload.impFile
    );
    if (index !== -1) {
      let mutatationImportFiles = [...state.importFiles.data];
      mutatationImportFiles[index].errmess = payload.errmess;
      state.importFiles.data = [...mutatationImportFiles];
    }
  },
  setCompletedImportFile: (state, payload) => {
    const index = state.importFiles.data.findIndex(
      item => item.impFile === payload.impFile
    );
    if (index !== -1) {
      let mutatationImportFiles = [...state.importFiles.data];
      mutatationImportFiles[index].processed = "1";
      state.importFiles.data = [...mutatationImportFiles];
    }
  },
  setStatusAddCodeplat: (state, payload) => (state.statusAddCodeplat = payload),
  clearStatusAddCodeplat: state => (state.statusAddCodeplat = null),
  setStatusLoadPackFile: (state, payload) =>
    (state.statusLoadPackFile = payload),
  clearStatusLoadPackFile: state => (state.statusLoadPackFile = null),
  setStatusLoadPackFileCheck: (state, payload) =>
    (state.statusLoadPackFileCheck = payload),
  clearStatusLoadPackFileCheck: state => (state.statusLoadPackFileCheck = null),
  setStatusImportFileCodeFirme: (state, payload) =>
    (state.statusImportFileCodeFirme = payload),
  clearStatusImportFileCodeFirme: state =>
    (state.statusImportFileCodeFirme = null),
  setStatusAddBand: (state, payload) => (state.statusAddBand = payload),
  clearStatusAddBand: state => (state.statusAddBand = null)
};

const actions = {
  async getPacksReceipts({ commit, state, rootState }) {
    try {
      commit("setLoading", true);
      const filter = state.packsReceiptsFilter;
      let params = {
        script: "web.wbtpack",
        funcname: "wbRunSelect",
        dtBegin: `${filter.period.dateBegin}`,
        dtEnd: `${filter.period.dateEnd}`
      };
      if (filter.organization.enabled) {
        params["codefirme"] = filter.organization.code;
      }
      if (filter.payment.enabled) {
        params["kindpay"] = filter.payment.code;
      }
      if (filter.sum.enabled) {
        params["sumBegin"] = filter.sum.sumBegin;
        params["sumEnd"] = filter.sum.sumEnd;
      }
      if (filter.showSpaced.enabled) {
        params["status"] = "2";
      }
      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: params
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );
      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setPacksReceipts", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setLoading", false);
    }
  },
  async getDeletedPacks({ commit, state, rootState }) {
    try {
      commit("setLoading", true);
      const filter = state.packsReceiptsFilter;
      let params = {
        script: "web.wbpackdel",
        funcname: "wbpackdelet",
        dtBegin: `${filter.period.dateBegin}`,
        dtEnd: `${filter.period.dateEnd}`
      };
      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: params
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );
      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setInfoReceipts", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setLoading", false);
    }
  },
  async getIndefiniteReceipts({ commit, rootState }, { npack }) {
    try {
      commit("setLoading", true);
      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbpackneopr",
            funcname: "wbpackneop",
            npack: `${npack}`
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );
      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setInfoReceipts", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setLoading", false);
    }
  },
  async getImportTypes({ commit, rootState }, { typeimport }) {
    try {
      commit("setImportTypesLoading", true);
      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbImportPack",
            funcname: "wbGetTypeImport",
            typeimport: `${typeimport}`
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );
      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setImportTypes", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setImportTypesLoading", false);
    }
  },
  async packsReceiptsAdd(
    { commit, rootState },
    {
      behavior,
      packnumber,
      datebank,
      codefirme,
      countband,
      kindpay,
      summa,
      sumprof,
      quantity,
      isimport,
      userid,
      confirm
    }
  ) {
    try {
      commit("setFullPageLoading", true);

      let params = {
        script: "web.wbpack",
        funcname: "wbRunEdit",
        behavior: `${behavior}`,
        APackNumber: `${packnumber}`,
        pDateBank: `${datebank}`,
        pCodeFirme: `${codefirme}`,
        pCountBand: `${countband}`,
        pKindPay: `${kindpay}`,
        pSumma: `${summa}`,
        sumprof: `${sumprof}`,
        AQuantity: `${quantity}`,
        isimport: `${isimport}`,
        userid: `${userid}`
      };

      if (confirm) {
        params["confirm"] = "1";
      }

      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: params
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setStatusModifyPacksReceipts", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  },
  async packsReceiptsEdit(
    { commit, rootState },
    {
      behavior,
      packnumber,
      datebank,
      codefirme,
      countband,
      kindpay,
      summa,
      sumprof,
      paysheetid,
      quantity,
      npack,
      isimport,
      userid,
      datebeginfact,
      confirm
    }
  ) {
    try {
      commit("setFullPageLoading", true);
      let params = {
        script: "web.wbpack",
        funcname: "wbRunEdit",
        behavior: `${behavior}`,
        APackNumber: `${packnumber}`,
        pDateBank: `${datebank}`,
        pCodeFirme: `${codefirme}`,
        pCountBand: `${countband}`,
        pKindPay: `${kindpay}`,
        pSumma: `${summa}`,
        sumprof: `${sumprof}`,
        paysheetid: `${paysheetid}`,
        AQuantity: `${quantity}`,
        npack: `${npack}`,
        isimport: `${isimport}`,
        userid: `${userid}`,
        datebeginfact: `${datebeginfact}`
      };

      if (confirm) {
        params["confirm"] = "1";
      }

      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: params
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setStatusModifyPacksReceipts", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  },
  async packsReceiptsDelete(
    { commit, rootState },
    {
      behavior,
      npack,
      status,
      kindpay,
      datebank,
      summa,
      codefirme,
      datebeginfact
    }
  ) {
    try {
      commit("setFullPageLoading", true);
      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbpack",
            funcname: "wbRunEdit",
            behavior: `${behavior}`,
            npack: `${npack}`,
            status: `${status}`,
            kindpay: `${kindpay}`,
            datebank: `${datebank}`,
            summa: `${summa}`,
            codefirme: `${codefirme}`,
            datebeginfact: `${datebeginfact}`
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setStatusModifyPacksReceipts", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  },
  async uploadFiles(
    { commit, rootState },
    { serverfolder, typeimport, codeimport, files }
  ) {
    try {
      commit("setFullPageLoading", true);

      const command = {
        cmd: "luaFunc",
        params: {
          script: "web.wbimportupload",
          funcname: "wbImpSaveFiles",
          savedir: `${serverfolder}`,
          typeimport: `${typeimport}`,
          codeimport: `${codeimport}`
        }
      };

      const formData = new FormData();
      formData.append("command", JSON.stringify(command));

      files.forEach(file => {
        formData.append("upload", file.raw);
      });

      const response = await Vue.axios.post(rootState.auth.base.url, formData, {
        headers: {
          Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
        }
      });

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setImportFilesBuffer", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  },
  async removeUploadDir({ commit, rootState }, { serverfolder }) {
    try {
      commit("setFullPageLoading", true);

      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbimportupload",
            funcname: "wbImpRemoveDir",
            savedir: `${serverfolder}`
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result != "ok") {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  },
  async getFileInfo(
    { commit, rootState },
    { codeimport, codefirme, codepage, kindpay, subs, fin, fip }
  ) {
    try {
      commit("setFullPageLoading", true);

      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbImportPack",
            funcname: "wbLoadGetInfo",
            fip: `${fip}`,
            fin: `${fin}`,
            pkindpay: `${kindpay}`,
            subs: `${subs}`,
            codeimport: `${codeimport}`,
            codefirme: `${codefirme}`,
            codepage: `${codepage}`
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setStatusInfoImportFile", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  },
  async checkImportFileCodeFirme(
    { commit, rootState },
    { codeimport, codepage, kindpay, subs, fin, fip }
  ) {
    try {
      commit("setFullPageLoading", true);

      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbImportPack",
            funcname: "wbLoadGetCodefirme",
            fip: `${fip}`,
            fin: `${fin}`,
            pkindpay: `${kindpay}`,
            subs: `${subs}`,
            codeimport: `${codeimport}`,
            codepage: `${codepage}`
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setStatusImportFileCodeFirme", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  },
  async loadPackFile(
    { commit, rootState },
    {
      codeimport,
      codefirme,
      codepage,
      kindpay,
      codeplat,
      subs,
      fin,
      fip,
      datapack,
      bankcodeplat,
      cfil
    }
  ) {
    try {
      commit("setFullPageLoading", true);

      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbImportPack",
            // script: "web.wbImportPackTest", // ### тестовая заглушка
            funcname: "wbLoadPackFile",
            fip: `${fip}`,
            fin: `${fin}`,
            pkindpay: `${kindpay}`,
            codeplat: `${codeplat}`,
            subs: `${subs}`,
            codeimport: `${codeimport}`,
            codefirme: `${codefirme}`,
            codepage: `${codepage}`,
            datapack: `${datapack}`,
            bankcodeplat: `${JSON.stringify(bankcodeplat)}`,
            cfil: `${JSON.stringify(cfil)}`
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setStatusLoadPackFile", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  },
  async loadPackFileCheck({ commit, rootState }, { packdata, behavior }) {
    try {
      commit("setFullPageLoading", true);

      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbImportPack",
            funcname: "wbLoadPackFilecheck",
            packdata: `${JSON.stringify(packdata)}`,
            behavior: `${behavior}`
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setStatusLoadPackFileCheck", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  },
  async addBand(
    { commit, rootState },
    { npack, nband, countpay, summband, sumprof }
  ) {
    try {
      commit("setFullPageLoading", true);

      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbAddBand",
            funcname: "runInsertBand",
            npack: `${npack}`,
            nband: `${nband}`,
            countpay: `${countpay}`,
            summband: `${summband}`,
            sumprof: `${sumprof}`
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setStatusAddBand", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  }
};

const getters = {
  packsReceiptsFilter: state => state.packsReceiptsFilter,
  packsReceipts: (state, rootState) => {
    let items = [];
    state.packsReceipts.data.forEach(item => {
      item["namefirme"] = nameFirme(
        rootState.params.gfirme.data,
        item.codefirme
      );
      item["kindname"] = kindName(rootState.params.gkindpay.data, item.kindpay);
      items.push(item);
    });
    return items;
  },
  infoReceipts: (state, rootState) => {
    let items = [];
    state.infoReceipts.data.forEach(item => {
      item["kindname"] = kindName(rootState.params.gkindpay.data, item.kindpay);
      item["namefirme"] = nameFirme(
        rootState.params.gfirme.data,
        item.codefirme
      );
      item["countfirme"] = countFirme(
        rootState.params.gfirme.data,
        item.codefirme
      );
      item["username"] = userName(rootState.params.gusers.data, item.userid);
      (item["payname"] = payName(rootState.params.codepay.data, item.codeplat)),
        items.push(item);
    });
    return items;
  },
  statusModifyPacksReceipts: state => state.statusModifyPacksReceipts,
  importTypes: state => state.importTypes.data,
  importTypesLoading: state => state.importTypesLoading,
  statusInfoImportFile: state => state.statusInfoImportFile,
  importFiles: state => state.importFiles.data,
  importFilesBuffer: state => {
    let items = [];
    state.importFilesBuffer.data.forEach(item => {
      item["status"] =
        item.impFile !== "" && item.reeName === "" && item.reePath === ""
          ? "1"
          : "0";
      items.push(item);
    });
    return items;
  },
  statusAddCodeplat: state => state.statusAddCodeplat,
  statusLoadPackFile: state => state.statusLoadPackFile,
  statusLoadPackFileCheck: state => state.statusLoadPackFileCheck,
  statusImportFileCodeFirme: state => state.statusImportFileCodeFirme,
  statusAddBand: state => state.statusAddBand
};

export default { state, mutations, actions, getters };
